export const CHECKOUT_STEPS = ['Meal Prep', 'Recipes', 'Secure Checkout'];
